import type { ReactNode } from 'react';

import { PencilIcon } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import {
    Dialog,
    DialogCloseButton,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@nesso/ui/primitives/dialog';

import { MAX_SELECTED_APPROACHES } from '@/entities/session';

type Props = {
    buttonClassName: string;
    disabled: boolean;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    children: ReactNode;
};

export function EditTreatmentApproachesDialog({
    buttonClassName,
    disabled,
    open,
    onOpenChange,
    children,
}: Props) {
    const onClose = () => onOpenChange(false);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    aria-label="Edit treatment approach"
                    className={buttonClassName}
                    disabled={disabled}
                >
                    <PencilIcon className="w-3 h-3" />
                </Button>
            </DialogTrigger>
            <DialogContent fullscreen showCloseButton={false}>
                <div className="flex flex-col h-full overflow-hidden">
                    <DialogHeader className="flex flex-row text-left items-center justify-between p-4 pb-2">
                        <div className="pt-2">
                            <DialogTitle>Treatment approach</DialogTitle>
                            <DialogDescription className="text-sm mt-1">
                                Choose up to {MAX_SELECTED_APPROACHES} approaches used in the
                                session
                            </DialogDescription>
                        </div>
                        <DialogCloseButton onClick={onClose} className="self-start" />
                    </DialogHeader>

                    {children}
                </div>
            </DialogContent>
        </Dialog>
    );
}
